/**
 * YNF自定义错误码
 * E 代表错误 error
 * E00000 ~ E00999 通用类错误
 * E01000 ~ E01999 网络错误
 * E02000 ~ E02999 元数据协议错误
 * E03000 ~ E03999 解析引擎错误
 * E04000 ~ E04999 渲染引擎错误
 * E05000 ~ E05999 组件错误
 * E06000 ~ E06999 公共业务错误
 * ~
 * E06000 ~ E06999 公共业务错误
 */
const errorCodes = {
  E00000: '通用类错误',
  E00001: '函数参数错误',
  E00002: '解密错误',

  E01000: '网络错误',
  E01001: '请求参数错误',
  E01002: '请求404',
  E01003: '请求无权限401',
  E01004: '请求超时',
  E01005: '资源文件加载失败',

  E02000: '元数据协议错误',

  E03000: '解析引擎错误',

  E04000: '渲染引擎错误',

  E05000: '组件错误',

  E06000: '公共业务错误'
}

/**
 * 格式化code码
 * @param {错误码} codes
 * @returns 格式化后的错误码
 */
const formatData = (codes) => {
  const arrs = [];
  for (const key in codes) {
    const obj = {
      code: key,
      text: codes[key]
    };
    Object.setPrototypeOf(obj, { toString: function () { return this.code + '(' + this.text + ')' } });
    arrs.push(obj);
  }
  return arrs;
}
export default formatData(errorCodes);
